export default __webpack_public_path__ + "static/media/autotone.e56db920.txt";